
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Currency } from '@components';
import { renderNumber } from '@share/utils';

import '../style.scss';

const zero = 0;

export interface IHotelCardPriceNewTemplateProps {
  currency: string;
  displayWalletSavings: boolean;
  marginatorPrice: number;
  marginatorPriceFinal: number | null | undefined;
  marginatorSavings: number;
  displaySupplierPublicPriceB2C: boolean;
  pubPrice: number;
  nightsCount: number;
  marginatorpricePerNight: number;
  breakdownTaxes?: boolean;
  isCars?: boolean;
}

export function HotelCardPriceNewTemplate(props: IHotelCardPriceNewTemplateProps) {
  const {
    currency,
    displayWalletSavings,
    marginatorPrice,
    marginatorPriceFinal,
    marginatorSavings,
    displaySupplierPublicPriceB2C,
    pubPrice,
    nightsCount,
    marginatorpricePerNight,
    breakdownTaxes,
    isCars,
  } = props;

  const hasBadge =
    (displayWalletSavings && (marginatorPrice - (marginatorPriceFinal ?? 0)) > zero) ||
    (marginatorSavings > zero && !displayWalletSavings && !displaySupplierPublicPriceB2C);

  return (
    <div
      className={`hotel-card-wrapper__price-new-template ${hasBadge ? 'hotel-card-wrapper__price-new-template--has-badge' : ''}`}
    >
      {/* Red savings badge (top right) */}
      {hasBadge && (
        <div className="hotel-card-wrapper__price-new-template-badge">
          <Currency currency={currency} />
          {displayWalletSavings
            ? (marginatorPrice - (marginatorPriceFinal ?? 0) >= 1
                ? Math.floor(marginatorPrice - (marginatorPriceFinal ?? 0))
                : renderNumber(marginatorPrice - (marginatorPriceFinal ?? 0), 2))
            : (marginatorSavings >= 1 ? Math.floor(marginatorSavings) : renderNumber(marginatorSavings, 2))}{' '}
          <FormattedMessage id="result.hotel.card.savings.off" />
        </div>
      )}
      {/* Line 1: $498 nightly */}
      <div className="hotel-card-wrapper__price-new-template-line hotel-card-wrapper__price-new-template-line--per-night">
        <span className="hotel-card-wrapper__price-new-template-current">
          <Currency currency={currency} />
          {displayWalletSavings && marginatorPriceFinal != null && nightsCount > 0
            ? renderNumber(marginatorPriceFinal / nightsCount, 2)
            : renderNumber(marginatorpricePerNight, 2)}
          {' '}
          <FormattedMessage id={isCars ? 'daily' : 'result.hotel.card.nightly'} />
        </span>
      </div>
      {/* Line 2: ~~$1,440~~ $996 total (same line) */}
      <div className="hotel-card-wrapper__price-new-template-line hotel-card-wrapper__price-new-template-line--total-row">
        {((displayWalletSavings ? marginatorPrice > zero : pubPrice > zero) && !displaySupplierPublicPriceB2C) && (
          <span className="hotel-card-wrapper__price-new-template-crossed">
            <Currency currency={currency} />
            {displayWalletSavings ? renderNumber(marginatorPrice, 2) : renderNumber(pubPrice, 2)}
          </span>
        )}
        <span className="hotel-card-wrapper__price-new-template-total-inline">
          <Currency currency={currency} />
          {renderNumber(marginatorPriceFinal, 2)} <FormattedMessage id="result.hotel.card.total" />
        </span>
      </div>
      {/* Line 3: Green checkmark + Total with taxes and fees */}
      <div className="hotel-card-wrapper__price-new-template-line hotel-card-wrapper__price-new-template-line--taxes-fees">
        <FontAwesomeIcon icon={faCheck} className="hotel-card-wrapper__price-new-template-check" />
        <FormattedMessage id={breakdownTaxes ? 'price.without.taxes.fees' : 'result.hotel.card.total.with.taxes.fees'} />
      </div>
    </div>
  );
}
